export default function formatVehicle(vehicle) {
  return `${vehicle.year} ${vehicle.make} ${vehicle.model} ${
    vehicle.series ? ` ${vehicle.series}` : ""
  }${vehicle.vin ? ` (${vehicle.vin.toUpperCase()})` : ""}`;
}
